import BonusManagementPage from './BonusManagementPage';

export default BonusManagementPage;
